import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {CurrentMakerSummaryFragment} from "~/api/generated";
import {selectMaker, useAppSelector} from "~/modules/redux";
import {HOME_PATH} from "~/modules/routing";

export const useProtectedMaker = (): [CurrentMakerSummaryFragment | undefined] => {
  const navigate = useNavigate();

  const maker = useAppSelector(selectMaker);

  useEffect(() => {
    // if maker doesn't exist, BE returns null
    maker === null && navigate(HOME_PATH);
  }, [maker, navigate]);

  return [maker as CurrentMakerSummaryFragment | undefined];
};
